export default "__VITE_ASSET__e9b0de2a__"